<template>
  <div class="app-tariff-option-box">
    <div class="tarif-box-details">
      <div class="box-head">
        <div class="box-ribbon" v-if="isActive">
          <span><slot name="lblOptionActive">Aktiv</slot></span>
        </div>
        <div class="box-head-left">
          <div class="box-head-title">
            <h4>
              <slot name="headline">Headline</slot>
            </h4>
          </div>
          <div class="box-head-data">
            <h4>
              <slot name="subline">Subline</slot>
            </h4>
          </div>
        </div>
      </div>
      <div class="box-body">
        <slot name="txt">Description</slot>
      </div>
      <div class="tarif-box-cta">
        <button @click="$emit('submit')" :disabled="isBtnDisabled">
          <slot name="btn">Button</slot>
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ServiceBox',
  components: {},
  data () {
    return {}
  },
  methods: {
    triggerErrorTracking () {
      const errMsg = this.getBackendErrorMessage
      if (errMsg !== null) {
        const data = {
          type: 'technical',
          message: errMsg.substring(0, 50),
          code: String(this.beErrorGetLastErrorCode())
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      }
    }
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isBtnDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
